import { useEffect, useRef, useState } from 'react'
import { useParams, Link } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { api, streamLogs } from '../../lib/api.js'
import { Status, Spinner } from '../../components/ui.jsx'

export function BuildLog() {
  const { slug, deploymentId } = useParams()
  const [lines, setLines] = useState([])
  const [status, setStatus] = useState(null)
  const [live, setLive] = useState(false)
  const boxRef = useRef(null)
  const pinnedRef = useRef(true)

  // El histórico se lee por REST; solo se abre el SSE si el build sigue vivo.
  const hist = useQuery({ queryKey: ['logs', slug, deploymentId], queryFn: () => api.logs(slug, deploymentId) })

  useEffect(() => {
    if (!hist.data) return
    setStatus(hist.data.status)
    setLines(hist.data.logs.split('\n'))
    if (hist.data.status !== 'running') return

    setLive(true)
    const stop = streamLogs(slug, deploymentId, {
      onStatus: (s) => setStatus(s.status),
      onLine: (line) => setLines((prev) => [...prev, line]),
      onEnd: () => setLive(false),
      onError: () => setLive(false),
    })
    return stop
  }, [hist.data, slug, deploymentId])

  // Autoscroll solo si el usuario no se ha desplazado hacia arriba a leer.
  useEffect(() => {
    const el = boxRef.current
    if (el && pinnedRef.current) el.scrollTop = el.scrollHeight
  }, [lines])

  const onScroll = () => {
    const el = boxRef.current
    if (el) pinnedRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 40
  }

  return (
    <>
      <div className="section-head">
        <div>
          <h1 className="h1">Registro de build</h1>
          <p className="lede" style={{ marginBottom: 0, display: 'flex', alignItems: 'center', gap: 10 }}>
            <Status status={status} />
            {live && <span style={{ color: 'var(--accent)', fontSize: 13 }}>en directo</span>}
          </p>
        </div>
        <Link className="btn secondary sm" to={`/p/${slug}/deployments`}>Volver</Link>
      </div>

      {hist.isPending && <Spinner />}
      {hist.isError && <div className="alert error">No se pudo leer el registro.</div>}
      {hist.data && (
        <div className="logs" ref={boxRef} onScroll={onScroll} style={{ marginTop: 18 }}>
          {lines.map((l, i) => <span className="l" key={i}>{l || ' '}</span>)}
        </div>
      )}
    </>
  )
}
